import type { ThunkDependencies } from "single-spa/store/thunk-dependencies";
import type { ThunkDispatchCommon, ThunkGetState } from "single-spa/store/types";
import { managementActions } from "../../action-creators";
import { getHsMappingFieldsThunk } from "../hubspotApi";
import type { ExportSettingsSourceType, HubspotPreDefinedType } from "../../type";
import { selectCacheToken } from "../../selectors/common";

export const getHsExclusionStatusThunk =
    () => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.hubspot.getIntegrationLeadFilterStatusAsync.request());

            const { value } = await deps.si.api.management.getHsExclusionStatus();

            dispatch(managementActions.hubspot.getIntegrationLeadFilterStatusAsync.success(value));
        } catch (error) {
            dispatch(managementActions.hubspot.getIntegrationLeadFilterStatusAsync.failure(error));
        }
    };

export const putHsStatusFieldThunk =
    (externalField: string) =>
    async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.hubspot.putStatusFieldAsync.request());

            const { value } = await deps.si.api.management.putHsStatusFields(externalField);

            if (value) {
                await dispatch(getHsMappingFieldsThunk());
                dispatch(managementActions.hubspot.putStatusFieldAsync.success());
            } else {
                dispatch(managementActions.hubspot.putStatusFieldAsync.failure("Can't update HS status"));
            }
        } catch (error) {
            dispatch(managementActions.hubspot.putStatusFieldAsync.failure(error));
        }
    };

export const putHsExcludeThunk =
    (payload?: boolean) => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.hubspot.putIntegrationLeadFilterStatusAsync.request());

            const {
                crmConnectionStatus: { isLeadsFilterEnabled },
            } = await deps.si.api.management.putHsExcludeStatus(payload);

            dispatch(managementActions.hubspot.putIntegrationLeadFilterStatusAsync.success(isLeadsFilterEnabled));
        } catch (error) {
            dispatch(managementActions.hubspot.putIntegrationLeadFilterStatusAsync.failure(error));
        }
    };

export const getHsExcludeStatusFieldsThunk =
    ({
        columnName,
        isPreDefined = false,
        type,
        sourceType,
    }: {
        columnName: string;
        isPreDefined: boolean;
        type: HubspotPreDefinedType;
        sourceType: ExportSettingsSourceType;
    }) =>
    async (dispatch: ThunkDispatchCommon, getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.hubspot.getExcludeStatusFieldsAsync.request());
            const cacheToken = selectCacheToken(getState());

            let response = undefined;

            if (isPreDefined) {
                response = await deps.si.api.management.getHsPreDefinedColumns(type, cacheToken);
            } else {
                response = await deps.si.api.management.getHsFields(columnName, type, cacheToken, sourceType);
            }

            dispatch(managementActions.hubspot.getExcludeStatusFieldsAsync.success(response));
        } catch (error) {
            dispatch(managementActions.hubspot.getHubspotStatusAsync.failure(error));
        }
    };

export const getHsExcludeAccountFieldsThunk =
    () => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.hubspot.getExcludeAccountFieldsAsync.request());

            const response = await deps.si.api.management.getHsExcludeAccountFields();
            dispatch(managementActions.hubspot.getExcludeAccountFieldsAsync.success(response));
        } catch (error) {
            dispatch(managementActions.hubspot.getExcludeAccountFieldsAsync.failure(error));
        }
    };
